import { useApi, createApiHook } from "../utils/apiUtils";

const useCreateUser = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const createUser = async (payload) => {
    startLoading();

    const response = await apiPost("/users/full_create", "Error al crear el usuario", payload);

    setResponse(response);
    return !response?.error;
  };

  return { createUser, data, error, loading };
};

export default useCreateUser;
